export function renderPanelPlotBands(parentElem, panelLayout, xPadding, plotBands, xScale) {

	const plotLinesGroupElem = parentElem.append('g')
		.attr('class', 'hw_panel_graph_plot_bands');

	plotBands.forEach(plotBand => {

		const x1 = plotBand.config.range[0] === null
			? panelLayout.x - xPadding
			: xScale(plotBand.config.range[0]);

		const x2 = plotBand.config.range[1] === null
			? panelLayout.x + panelLayout.width + xPadding
			: xScale(plotBand.config.range[1]);

		plotLinesGroupElem.append('rect')
			.attr('class', `hw_panel_graph_plot_band_${plotBand.config.name}`)
			.attr('x', x1)
			.attr('y', panelLayout.y)
			.attr('width', x2 - x1)
			.attr('height', panelLayout.height);

	});

}



// WEBPACK FOOTER //
// ./utils/panelgraph/functions/render-panel-plot-bands.js